export function removeUnderscores(value: string): string {
  return value.replace(/_/g, ' ');
}

export function capitalizeWords(value: string): string {
  return value
    .split(' ')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
